import { useQuery } from '@tanstack/react-query';

import { SharedEndpointQueryKeys } from '../../Shared/constants/sharedEnpoints';
import { ApiError } from '../../Shared/interfaces/ApiError';
import useApiClient from '../../Shared/services/api';
import { getCategories } from '../../Shared/services/user/userService';
import { UserCategoriesResponse } from '../interfaces/userInterfaces';

export const useGetCategories = (isEnabled: boolean) => {
    const api = useApiClient();
    return useQuery<UserCategoriesResponse, ApiError>({
        queryKey: [SharedEndpointQueryKeys.GET_CATEGORIES],
        queryFn: () => getCategories(api),
        enabled: isEnabled

    });
}
